import sectionSubcribeEmailCss from '../css-snippets/section-subcribe-email';

const html = `
<style>${sectionSubcribeEmailCss}</style>
<div data-attribute="card-container" data-id="unique-id" data-background="#f3f3f3" style="background-color: #f3f3f3;" data-top-padding="true" data-bottom-padding="true">
    <div class="container-page container" data-attribute="container-page" data-show-style="true">
        <div class="wrap-card">
            <h2 data-attribute="title-card" class="title-card">Subscribe to our emails</h2>
            <p data-attribute="description-card" class="description-card">
                Be the first to know about new collections and exclusive offers.
            </p>
            <form method="post" action="#" class="form-subcribe" data-attribute="form-subcribe">
                <div class="wrap-input-email">
                    <input type="email" placeholder="Enter your email" data-attribute="input-email" class="input-email">
                    <button type="button" data-attribute="button-submit" class="button-submit">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path></svg>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
`;
export default html;
